import { createStore } from 'satcheljs';
import PivotEnableDisableDialogStore from './schema/PivotEnableDisableDialogStore';

const pivotEnableDisableDialogStore: PivotEnableDisableDialogStore = {
    enabledDisabledPivots: [],
    isPivotEnableDisableDialogShown: false,
};

export let getStore = createStore<PivotEnableDisableDialogStore>(
    'pivotEnableDisableDialogStore',
    pivotEnableDisableDialogStore
);

const store = getStore();
export default store;
